import * as React from 'react';
export const bancobpmSvg = React.forwardRef(function bancobpmSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#142B57',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'm4 17.937 6.267-.01c2.113-1.724 5.04-2.791 8.273-2.791 3.216 0 6.127 1.055 8.236 2.761H28C25.389 15.542 20.998 14 16.023 14 11.019 14 6.607 15.562 4 17.937Z',
      fill: '#fff',
    }),
  );
});
bancobpmSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var bancobpm = {
  category: 'brand',
  colorable: false,
  name: 'bancobpm',
  svg: bancobpmSvg,
};
